import { render, staticRenderFns } from "./DepositTakingInfo.vue?vue&type=template&id=251c5c06"
import script from "./DepositTakingInfo.vue?vue&type=script&lang=js"
export * from "./DepositTakingInfo.vue?vue&type=script&lang=js"
import style0 from "./DepositTakingInfo.vue?vue&type=style&index=0&id=251c5c06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports